import { MetricTypes } from "../autogen/metrics";

export const SOURCE_METRICS = [
  MetricTypes.AD_SPEND,
  MetricTypes.AD_ATTRIBUTED_CONVERSION_ROAS,
  MetricTypes.AD_CTR,
  MetricTypes.AD_IMPRESSIONS,
  MetricTypes.AD_AOV,
  MetricTypes.AD_CONVERSION_RATE,
];
